import Axios from '~/utils/axios';
import { sentryCaptureException } from '~/errors/sentry';

export type ValidateDataProps = {
   dmcId?: string;
   embassyCode: string;
   nationalityCode: string;
   countryCode: string;
   flightInfo: {
      arrivalFlightNumber: string;
      arrivalFlightDate: string;
      arrivalFlightTime: string;
      arrivalCarrierCode: string;
      departureFlightNumber?: string;
      departureFlightDate?: string;
      departureFlightTime?: string;
      departureCarrierCode?: string;
   };
};

export const validateSupervisorFlightDetails = async (body: ValidateDataProps) => {
   try {
      const { data, status } = await Axios.post(`/dhamen/v1/visa-request/dhamen-validation`, body);

      if (status === 200) {
         return { data: data };
      } else {
         throw new Error(data?.error || data?.original?.error || 'Something went wrong');
      }
   } catch (error: any) {
      console.log(error);
      sentryCaptureException(error);
      return { error };
   }
};
